import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatIban',
  standalone: true,
})
export class FormatIbanPipe implements PipeTransform {
  transform(value?: string): string {
    if (!value) return '';
    return value.replace(/(.{4})/g, '$1 ').trim();
  }
}
